<template>
  <div class="md-flex lg-flex items-center">
    <div class="flex flex-wrap col-12 relative grey-bg p3 justify-center">
      <div class="col-12">
        <div class="col-12 py2 flex justify-center items-center">
          <div class="flex px2 justify-center blue h3n bold">Bienvenue {{ user.firstname }} {{ user.lastname }}</div>
        </div>
        <hr class="horizontal-divisor py2">
      </div>
      <div class="col-12 md-col-9" v-html="homepageDisplay"></div>
      <div class="col-12 flex flex-wrap justify-center">
        <div v-if="!isPegaseWorkspace">
          <div v-if="showOffers">
            <div class="flex col-12 justify-center center h3n semi-bold caps p2">
              Les produits que nous vous recommandons :
            </div>
            <div v-for="item in offers" :key="item.name">
              <div v-for="offer in item.product.dynamo_offers.filter(o => !o.isDisabled)" :key="`${item.name}-${offer.name}`" class="mb1">
                <div class="col-12 px2 flex flex-wrap no-box white-bg">
                  <div class="flex flex-wrap col-12">
                    <span class="mb1 mt2 h6n col-6">
                      {{ item.product.name }}
                    </span>
                    <h3 v-if="!offer.isDisabled" class="mb1 mt2 h6n right-align col-6">
                      À partir de
                      {{ `${offer.detail.lowest_price_label}${offer.detail.recurring?'/mois':''}` }}
                    </h3>
                    <h4 class="flex col-12 h6n mb1 mt0 regular">
                      {{ offer.name }}
                    </h4>

                    <div class="flex">
                      <div class="flex flex-wrap mr1">
                        <span class="mt1 h7n caps">Participant :</span>
                        <h4 class="my0 regular h7n col-12">{{ (item.full_name) }}</h4>
                      </div>
                      <div v-if="offer.detail?.end_timestamp" class="flex flex-wrap">
                        <span class="mt1 h7n col-12 caps regular">Date de fin de validité:</span>
                        <h4 class="my0 regular h7n col-12">
                          <i class="icon icon-date-check-icon mr1"></i>
                          {{ offer.detail.end_timestamp }}
                        </h4>
                      </div>
                    </div>
                  </div>

                  <div class="flex col-12 justify-center p2">
                    <div class="flex items-center justify-center">
                      <a v-if="offer.isForm" :href="offer.product_form_link" :class="['btn-reserve large-text white-color black-bg py-small px3', { 'disabled' : offer.isDisabled }]">
                        {{ product.product_cta_name }}
                      </a>
                      <a v-else-if="offer.isDisabled" href="#" class="btn-reserve large-text white-color black-bg py-small px3 disabled">
                        {{ offer.isVentreSurLaPlace ? "Vente sur place" : "Bientôt disponible" }}
                      </a>
                      <a v-else :href="`${generateFunnelUrl(offer)}&user=${item.customer_uuid}`" :class="['btn-reserve large-text white-color black-bg py-small px3', { 'disabled' : offer.isDisabled }]">
                        Acheter
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="isPegaseWorkspace" class="red">
          Vous avez des offres disponible, n'hésitez pas à les retrouver dans votre espace "Mes offres"
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { computed, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { routeIsCurrentComponent, generateFunnelUrl } from '@/mixins/utils';
import UserPhoto from '@/components/elements/UserPhoto';

export default {
  components: { UserPhoto },
  setup () {
    const store = useStore();
    const route = useRoute();
    const user = computed(() => store.state.user);
    const orders = computed(() => (store.state.user.orders || []).map(order => ({ items: order.order.order_items, isPaid: order.isPaid })));
    const contacts = computed(() => store.state.contacts);
    const workspace = computed(() => store.state.siteInfo.workspace);

    const isPegaseWorkspace = computed(() => store.state.siteInfo.isPegase);

    const allowed_products = computed(() => {
      const initialState = [];
      contacts.value.map(
        contact => (contact.allowed_products || []).map(ap => {
          if (ap && ap.product && ap.product.workspace === workspace.value) {
            initialState.push({ ...ap, customer_uuid: contact.uuid, full_name: `${contact.firstname} ${contact.lastname}` });
          }
        })
      );
      return initialState;
    });

    const offers = computed(() => allowed_products.value.filter(ap => ap.product && !(orders.value || []).some(order => order.isPaid && (order.items || []).some(i => i.customer.uuid === ap.customer_uuid && i.product_uuid === ap.product_uuid))));

    const showOffers = computed(() => offers.value.reduce((previousValue, currentValue) => previousValue + currentValue.product.dynamo_offers.filter(o => !o.isDisabled).length, 0) !== 0);
    const homepageDisplay = computed(() => store.getters.displayContent('HOME_PAGE_SECTION'));
    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

    return { generateFunnelUrl, isPegaseWorkspace, user, contacts, offers, homepageDisplay, showOffers, routeMatchesComponent };
  }
};
</script>

<style lang="scss">
.home-notifications-block {
  padding: 0.4rem 0rem;
}

.horizontal-divisor {
  width: 150px;
  height: 0px;
  border-top: 3px solid white;
  border-left: 0px;
  border-right: 0px;
  border-bottom: 0px;
}
</style>
